import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const profileManagerService = {};

// getProfile
profileManagerService.getProfile = function (id) {
  return fetch({
    url: `${env.API_MSP}/my/profile`,
    method: "get",
  });
};

// updateProfile
profileManagerService.updateProfile = function (display_name, avatar_id) {
  return fetch({
    url: `${env.API_MSP}/my/profile`,
    method: "post",
    data: {
      display_name,
      avatar_id: avatar_id ? avatar_id : undefined,
    },
  });
};

// getAvatar
profileManagerService.getAvatar = function (avatarId) {
  return fetch({
    url: `${env.API_MSP}/my/avatar/${avatarId}`,
    method: "get",
    responseType: "blob",
  });
};

// uploadAvatar
profileManagerService.uploadAvatar = function (data) {
  return fetch({
    url: `${env.API_MSP}/my/avatar`,
    method: "post",
    data,
  });
};

export default profileManagerService;
